module.exports = __webpack_public_path__ + "static/media/arrow_up_circle.e25c329a.svg";